/**
* @summary - Component that Provides Work Group Creation Page
* @author Yuvasri S
* @since 2024-05-28
*/
import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import CreateWorkGroup from '../../components/workgroupcomponents/CreateWorkGroup'

function WorkGroupRegister({renderPageContent}) {
    return (
        <>
                        <CreateWorkGroup renderPageContent={renderPageContent}/>
                       
                       
        </>
    )
}

export default WorkGroupRegister;